import Blog from "../classes/blog.js";

const initBlock = async function( block ) {
	new Blog( block );
};

themeUtils.loadBlock( initBlock, "blog", ".section-blog" );
